import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'navy' | 'navy-light';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'navy'
}: SectionProps) {
  const bgColor = bg === 'navy-light' ? 'bg-navy-light' : 'bg-navy';
  return <section id={id} className={`py-12 md:py-32 ${bgColor} ${className}`} data-id="element-115">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-5xl mx-auto px-4 md:px-12" data-id="element-116">
        {children}
      </motion.div>
    </section>;
}